import type { RecommendCategoryItemRequest } from '~/api/data-source/recommend';
import { recommendRepository } from '~/api/repository/recommend';

export const RECOMMEND_QUERY_KEY = {
  all: ['recommend'] as const,

  // 홈 - 구매한 상품의 연관상품 추천
  homeCategoryItems: () => ({
    queryKey: [...RECOMMEND_QUERY_KEY.all, 'home-category-items'] as const,
    queryFn: () => recommendRepository.getHomeCategoryItems(),
  }),

  // 분류 기반 연관상품 추천 (offerIds 기반)
  // offerIds 순서가 달라도 동일 캐시로 취급되도록 정렬해 키를 안정화한다.
  categoryItems: (request: RecommendCategoryItemRequest) => {
    const sortedOfferIds = [...request.offerIds].sort((a, b) => a - b);

    return {
      queryKey: [
        ...RECOMMEND_QUERY_KEY.all,
        'category-items',
        sortedOfferIds,
      ] as const,
      queryFn: () => recommendRepository.getCategoryItems(request),
    };
  },

  // 업종별 인기상품 추천
  classificationItems: () => ({
    queryKey: [...RECOMMEND_QUERY_KEY.all, 'classification-items'] as const,
    queryFn: () => recommendRepository.getClassificationItems(),
  }),
};
